export default __webpack_public_path__ + "static/lsa-fonts-mobile-cbccec51fcc8d7305697b57036867a86.jpg";